import Vue from "vue"
import Router from "vue-router"
import store from "@/store"
import _ from "lodash"
import Home from "./views/Home.vue"
import Layout from "./views/Layout.vue"

Vue.use(Router);

const originalPush: any = Router.prototype.push;
Router.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err);
};

// 页面刷新时，重新赋值token
if (window.localStorage.getItem("token")) {
  store.commit("user/saveToken", window.localStorage.getItem("token"));
}

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "登录",
      component: () => import("./views/Login.vue"),
      beforeEnter: (to: any, from: any, next: any) => {
        const { query } = to
        if (query.token) {
          // 快速登录
          const token = query.token.substring(0, query.token.length - 7)
          window.localStorage.setItem("token", token)
          window.location.href = "/"
        }
        next()
      }
    },
    {
      name: "问卷调查",
      path: "/invest/summit",
      component: () => import("@/views/invest/submit.vue"),
      meta: { requireAuth: false }
    },
    // {
    //     path: '/spe',
    //     name: '羽约场馆App新版发布',
    //     component: () => import('@/views/spe.vue')
    // },
    {
      path: "",
      // name: "管理后台",
      component: Layout,
      meta: { requireAuth: true },
      children: [
        {
          path: "/",
          name: "首页",
          component: Home,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/settings",
          name: "参数设置",
          component: () => import("@/views/settings/Index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/list",
          name: "管理员账号管理",
          component: () => import("@/views/admin/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/ai-broadcast-test",
          name: "AI广播测试",
          component: () => import("@/views/admin/aibroadcast.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/equipoplogs",
          name: "硬件控制记录",
          component: () => import("@/views/EquipOpLogs.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work-order/list",
          name: "工单列表",
          component: () => import("@/views/workorders/Index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/message/announcement",
          name: "系统公告",
          component: () => import("@/views/announcement/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/message/notification",
          name: "消息通知",
          component: () => import("@/views/message/notification.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/message/adminpush",
          name: "后台App推送",
          component: () => import("@/views/message/adminpush.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/train/organization",
          name: "教练列表",
          component: () => import("@/views/train/origanization.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/train/studentrecord",
          name: "学员记录表",
          component: () => import("@/views/train/student.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/user/overview",
          name: "用户概况",
          component: () => import("@/views/users/overview.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/user/list",
          name: "用户列表",
          component: () => import("@/views/users/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/wechatdown",
          name: "微信下载",
          component: () => import("@/views/users/wechatdown.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/cards",
          name: "场馆会员卡",
          component: () => import("@/views/card/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        // {
        //     path: '/admin/cards/list',
        //     name: '会员卡列表',
        //     component: () => import('@/views/card/list.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        {
          path: "/admin/settlementsetting",
          name: "结算项目",
          component: () => import("@/views/settlementsetting/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/area",
          name: "合作地区管理",
          component: () => import("@/views/area/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/financial-records",
          name: "结算记录",
          component: () => import("@/views/finacy/financial-records.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/wechat-settlement",
          name: "微信结算",
          component: () => import("@/views/finacy/wechat-settlement.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/financial-correct",
          name: "结算纠错",
          component: () => import("@/views/finacy/financial-correct.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/alipay-settlement",
          name: "支付宝结算",
          component: () => import("@/views/finacy/alipay-settlement.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/reconciliation",
          name: "对账记录",
          component: () => import("@/views/finacy/reconciliation.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/pay-records",
          name: "支付记录",
          component: () => import("@/views/finacy/pay-records.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/recharge-records",
          name: "充值记录",
          component: () => import("@/views/finacy/recharge-records.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/yuyue-balance",
          name: "羽约余额",
          component: () => import("@/views/finacy/yuyue-balance.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/withdraw",
          name: "提现记录",
          component: () => import("@/views/finacy/withdraw.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/refund-records",
          name: "退款记录",
          component: () => import("@/views/finacy/refund-records.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/redpacket",
          name: "馆长红包",
          component: () => import("@/views/finacy/redpacket.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/valueadded",
          name: "增值服务",
          component: () => import("@/views/finacy/valueadded.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/discounts",
          name: "抵用折扣",
          component: () => import("@/views/finacy/discounts.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/reductions",
          name: "立减金生成记录",
          component: () => import("@/views/finacy/reductions.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy/bill",
          name: "账单记录",
          component: () => import("@/views/finacy/bill.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bill/overview",
          name: "订单概况",
          component: () => import("@/views/bill/overview.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bill/share",
          name: "订单分享记录",
          component: () => import("@/views/bill/share.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bill/services",
          name: "场馆服务订单",
          component: () => import("@/views/bill/services.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bill/deposit",
          name: "AI智能工作站",
          component: () => import("@/views/bill/deposit.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bill/devops",
          name: "运维服务费订单",
          component: () => import("@/views/bill/devops.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bill/:key",
          name: "订单管理",
          component: () => import("@/views/bill/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        // {
        //     path: '/bill',
        //     meta: {
        //         redirect: '/bill/all'
        //     }
        // },
        {
          path: "/billcard",
          component: () => import("@/views/bill/card.vue"),
          meta: {
            requireAuth: true
          }
        },

        {
          path: "/billphone",
          name: "电话订场",
          component: () => import("@/views/bill/phone.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finacy",
          meta: {
            redirect: "/finacy/financial-records"
          }
        },
        {
          path: "/user",
          redirect: "/user/list"
        },
        // {
        //     path: '/bill/play',
        //     name: '普通订单',
        //     component: () => import('@/views/bill/play.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/bill/product',
        //     name: '新增羽约时间订单',
        //     component: () => import('@/views/bill/product.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/bill/booking',
        //     name: '手动添加订单',
        //     component: () => import('@/views/bill/booking.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/bill/robot',
        //     name: '小羽机器人订单',
        //     component: () => import('@/views/bill/robot.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/bill/bun',
        //     name: '包场订单',
        //     component: () => import('@/views/bill/bun.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/bill/peaks',
        //     name: '高低峰营销订单',
        //     component: () => import('@/views/bill/peaks.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/bill/refund',
        //     name: '退款订单',
        //     component: () => import('@/views/bill/refund.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        {
          path: "/stadium",
          meta: {
            redirect: "/stadium/list/verified"
          }
        },
        {
          path: "/stadium/overview",
          name: "场馆概况",
          component: () => import("@/views/stadium/overview.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/statistics",
          name: "降本增收分析",
          component: () => import("@/views/stadium/statistics.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/list",
          name: "场馆列表",
          component: () => import("@/views/stadium/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/add",
          name: "添加场馆",
          component: () => import("@/views/stadium/add.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/detail",
          name: "场馆详情",
          component: () => import("@/views/stadium/detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/list/:key",
          name: "已入驻场馆",
          component: () => import("@/views/stadium/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/bp-submit",
          component: () => import("@/views/stadium/bp-submit.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/all",
          component: () => import("@/views/stadium/index.vue"),
          props: { stype: "all" },
          meta: { requireAuth: true }
        },
        {
          path: "/stadium/newly",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "newly"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/pending",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "pending"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/active",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "active"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/database",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "database"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/internal",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "internal"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/wechat",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "wechat"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/limitai",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "limitai"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/ai",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "ai"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/tel",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "tel"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/24ai",
          component: () => import("@/views/stadium/index.vue"),
          props: {
            stype: "24ai"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/params-setting",
          component: () => import("@/views/stadium/param_setting.vue"),
          props: {
            stype: "params-setting"
          },
          meta: {
            requireAuth: true
          }
        },
        // {
        //     path: '/stadium/list/verified',
        //     name: '已核实场馆',
        //     component: () => import('@/views/stadium/index.vue'),
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        {
          path: "/stadium/discovery",
          name: "上报场馆记录",
          component: () => import("@/views/stadium/discovery.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/new",
          name: "新注册场馆",
          component: () => import("@/views/stadium/new.vue"),
          props: {
            stype: "new"
          },
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/statistics-analy",
          meta: {
            redirect: "/statistics-analy/board"
          }
        },
        {
          path: "/statistics-analy/board",
          name: "数据看板",
          component: () => import("@/views/statistics-analy/board.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/statistics-analy/city",
          name: "全国城市数据分布看板",
          component: () => import("@/views/statistics-analy/city.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/statistics-analy/hour24",
          name: "全国24小时分布看板",
          component: () => import("@/views/statistics-analy/hour24.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/statistics-analy/growth-curve",
          name: "数据增长曲线图",
          component: () => import("@/views/statistics-analy/growth-curve.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/statistics-analy/pie-chart",
          name: "数据占比饼图",
          component: () => import("@/views/statistics-analy/pie-chart.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/statistics-analy/stadium",
          name: "场馆数据",
          component: () => import("@/views/statistics-analy/stadium.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/release/detail",
          name: "详情",
          component: () => import("@/views/apprelease/detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/release/:key",
          name: "应用发布",
          component: () => import("@/views/apprelease/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/appstore",
          name: "应用市场",
          component: () => import("@/views/apprelease/appstore.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/agreement",
          name: "内容管理",
          component: () => import("@/views/agreement/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/admin/agreement/detail",
          // name: "详情",
          component: () => import("@/views/agreement/detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/manager",
          name: "新注册馆长",
          component: () => import("@/views/stadium/manager.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/projects",
          name: "合作进度管理",
          component: () => import("@/views/projects/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/projects/detail",
          name: "合作进度详情",
          component: () => import("@/views/projects/detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/agreement-record",
          name: "协议同意记录",
          component: () => import("@/views/agreement/record.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/wechatnotify",
          name: "微信接收人管理",
          component: () => import("@/views/wechatnotify/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/invitecode",
          name: "邀请码申请记录",
          component: () => import("@/views/invitecode/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/clubs",
          name: "俱乐部管理",
          component: () => import("@/views/clubs/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/allstadiums",
          name: "全国场馆档案管理",
          component: () => import("@/views/allstadiums/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/help",
          name: "问与答",
          component: () => import("@/views/help/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/manage-record",
          name: "工作记录",
          component: () => import("@/views/manage-record/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/oplatform/app",
          name: "应用列表",
          component: () => import("@/views/oplatform/app/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/oplatform/auth_user_groups",
          name: "粉丝分组管理",
          component: () => import("@/views/oplatform/auth_user_groups/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/oplatform/templatemessage",
          name: "模板消息管理",
          component: () => import("@/views/oplatform/templatemessage/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/wechat/fans",
          name: "粉丝管理",
          component: () => import("@/views/wechat/fans.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/track",
          // name: "入驻行为分析",
          component: () => import("@/views/stadium/track.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/track/detail",
          // name: "入驻行为分析",
          component: () => import("@/views/stadium/track_detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/track/list",
          // name: "入驻行为分析",
          component: () => import("@/views/stadium/track_list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/new-list/track-detail",
          name: "入驻行为分析",
          component: () => import("@/views/stadium/track_detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium/claim",
          name: "场馆认领记录",
          component: () => import("@/views/stadium/claim.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/stadium-vip-excel",
          name: "会员卡导入失败处理",
          component: () => import("@/views/workorders/stadiumvipexcel.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/member/upload",
          name: "拍照上传会员",
          component: () => import("@/views/member/upload.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/login-auth-ignore",
          name: "不需要验证API",
          component: () => import("@/views/loginauthignore/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/syslog/stadium-user",
          name: "新馆长",
          component: () => import("@/views/syslog/stadiumuser.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/syslog/enterapply/operation",
          name: "",
          component: () => import("@/views/syslog/enterapply.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/syslog/enterapply/action",
          name: "",
          component: () => import("@/views/syslog/enterapply-action.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/syslog/track",
          name: "轨迹",
          component: () => import("@/views/syslog/track.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/operationlogs",
          name: "操作日志",
          component: () => import("@/views/operationlogs/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "广告",
          path: "/adserver/banners",
          component: () => import("@/views/adserver/banners/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "网站或应用",
          path: "/adserver/websites",
          component: () => import("@/views/adserver/websites/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "广告位",
          path: "/adserver/zones",
          component: () => import("@/views/adserver/zones/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "统计",
          path: "/adserver/trackers",
          component: () => import("@/views/adserver/trackers/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "场馆主体",
          path: "/customers/list",
          component: () => import("@/views/customers/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "短信发送记录",
          path: "/sms/list",
          component: () => import("@/views/sms/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "短信群发",
          path: "/sms/admin",
          component: () => import("@/views/sms/admin.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "本机号码发送",
          path: "/sms/app",
          component: () => import("@/views/sms/app.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "推广链接管理",
          path: "/shorturl/list",
          component: () => import("@/views/shorturl/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "点击明细",
          path: "/shorturl/log",
          component: () => import("@/views/shorturl/log.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "APP功能控制",
          path: "/appmodules/list",
          component: () => import("@/views/appmodules/index.vue"),
          meta: {
            requireAuth: true
          }
        },

        {
          name: "短信模板",
          path: "/sms/tpl",
          component: () => import("@/views/sms/tpl.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "问题分类管理",
          path: "/work-order/category",
          component: () => import("@/views/workorders/category.vue"),

          meta: {
            requireAuth: true
          }
        },

        {
          name: "小羽组局",
          path: "/organizegame/group-xiaoyu",
          component: () => import("@/views/organizegame/group-xiaoyu.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "常用语管理",
          path: "/work-order/phrase",
          component: () => import("@/views/workorders/phrase.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "感知组局",
          path: "/organizegame/group-perception",
          component: () => import("@/views/organizegame/group-perception.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "入驻申请审核",
          path: "/enterapply/list",
          component: () => import("@/views/enterapply/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "海报管理",
          path: "/poster/list",
          component: () => import("@/views/poster/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "海报模板编辑",
          path: "/poster/add-new",
          component: () => import("@/views/poster/add_new.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "海报使用明细",
          path: "/poster/logs",
          component: () => import("@/views/poster/logs.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "场馆海报",
          path: "/poster/stadiums",
          component: () => import("@/views/poster/stadiums.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "精准营销",
          path: "/precisionmarketing/list",
          component: () => import("@/views/precisionmarketing/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "精准营销投诉",
          path: "/precisionmarketing/complaint",
          component: () => import("@/views/precisionmarketing/complaint.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "精准营销明细",
          path: "/precisionmarketing/logs",
          component: () => import("@/views/precisionmarketing/logs.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "AI营销",
          path: "/dmarketing/index",
          component: () => import("@/views/dmarketing/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "敏感词管理",
          path: "/sensitive",
          component: () => import("@/views/sensitive/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "本机外呼",
          path: "/tel/list",
          component: () => import("@/views/tel/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "配置管理",
          path: "/options/list",
          component: () => import("@/views/options/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "小羽服务设置",
          path: "/userservices",
          component: () => import("@/views/users/services.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "积分明细",
          path: "/credit/list",
          component: () => import("@/views/users/credits.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "消息中心",
          path: "/notification",
          component: () => import("@/views/notification/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "门禁记录",
          path: "/admin/gate-access-record",
          component: () => import("@/views/gate_access_record.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "隐私号码绑定记录",
          path: "/private-tel",
          component: () => import("@/views/privatetel/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "隐私电话号码池管理",
          path: "/private_phones",
          component: () => import("@/views/privatetel/phones.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "黑名单",
          path: "/block-list",
          component: () => import("@/views/users/blocklist.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "添加球友请求",
          path: "/user-player/add-request",
          component: () => import("@/views/users/add-request.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "taisam机器人账号",
          path: "/taisam-account",
          component: () => import("@/views/taisam-account/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "软文分类",
          path: "/cms/categories",
          component: () => import("@/views/cms/categories.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "软文内容",
          path: "/cms/contents",
          component: () => import("@/views/cms/contents.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "拨打电话行为跟踪",
          path: "/tel/logs",
          component: () => import("@/views/tel/logs.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "",
          path: "/stadium/edit-log",
          component: () => import("@/views/stadium/edit_log.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "",
          path: "/product-features",
          component: () => import("@/views/product-features/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "绑线管理",
          path: "/wire-bill",
          component: () => import("@/views/bill/wire_bill.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "数据分析",
          path: "/statistics-analy/overview",
          component: () => import("@/views/statistics-analy/overview.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "版本用户数量",
          path: "/apprelease/statistics",
          component: () => import("@/views/apprelease/statistics.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          // name: "场馆调研报告",
          path: "/stadium/research-report",
          component: () => import("@/views/stadium/research_report.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "场馆调研报告",
          path: "/stadium/research-report-edit",
          component: () => import("@/views/stadium/research_report_edit.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "服务列表",
          path: "/products/list",
          component: () => import("@/views/products/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "服务类别",
          path: "/products/categories",
          component: () => import("@/views/products/categories.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "单独定价",
          path: "/products/setting",
          component: () => import("@/views/products/setting.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "对账",
          path: "/finacy/account-report",
          component: () => import("@/views/finacy/account-report.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "对账详情",
          path: "/finacy/account-report-detail",
          component: () => import("@/views/finacy/account-report-detail.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "企业小程序",
          path: "/oplatform/weapp0",
          component: () => import("@/views/oplatform/weapp/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "个人小程序",
          path: "/oplatform/weapp1",
          component: () => import("@/views/oplatform/weapp/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "试用小程序",
          path: "/oplatform/weapp2",
          component: () => import("@/views/oplatform/weapp/index.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "小程序模板库",
          path: "/oplatform/wxatemplate",
          component: () => import("@/views/oplatform/weapp/template.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "用户活跃度",
          path: "/statistics-analy/user-activity",
          component: () => import("@/views/statistics-analy/user-activity.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "节假日设置",
          path: "/shutdowns",
          component: () => import("@/views/stadium/shutdowns.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "物料分类",
          path: "/bom/material-categories",
          component: () => import("@/views/bom/material-categories/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "物料管理",
          path: "/bom/materials",
          component: () => import("@/views/bom/materials/list.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "售卖时长统计",
          path: "/statistics-analy/hour-count",
          component: () => import("@/views/statistics-analy/hour-count.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "会员卡销售统计",
          path: "/statistics-analy/card-count",
          component: () => import("@/views/statistics-analy/card-count.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "降本增收",
          path: "/statistics-analy/taisam",
          component: () => import("@/views/statistics-analy/taisam.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "球友导入",
          path: "/users/contacts",
          component: () => import("@/views/users/contacts.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "员工信息",
          path: "/stadiumcrm/attence",
          component: () => import("@/views/stadiumcrm/attence.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "打卡记录",
          path: "/stadiumcrm/attencelog",
          component: () => import("@/views/stadiumcrm/attencelog.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "打卡统计",
          path: "/stadiumcrm/statistics",
          component: () => import("@/views/stadiumcrm/statistics.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "对账汇总表",
          path: "/finacy/statistics-excel",
          component: () => import("@/views/finacy/statistics-excel.vue"),
          meta: {
            requireAuth: true
          }
        },
        {
          name: "场馆管理",
          path: "/invest/stadium",
          component: () => import("@/views/invest/stadium/stadium.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "场馆评估",
          path: "/invest/stadium_assessment",
          component: () => import("@/views/invest/stadium/stadium_assessment.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "评估审核",
          path: "/invest/stadium_estimate",
          component: () => import("@/views/invest/stadium/stadium_estimate.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "投资管理-场馆详情",
          path: "/invest/stadium_detail",
          component: () => import("@/views/invest/detail/detail.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "我的场馆",
          path: "/invest/mine_stadium",
          component: () => import("@/views/invest/mine/stadiums.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "我的场馆评估",
          path: "/invest/mine_stadium_assessment",
          component: () => import("@/views/invest/mine/stadium_assessment.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "我的评估审核",
          path: "/invest/mine_stadium_estimate",
          component: () => import("@/views/invest/mine/stadium_estimate.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "审核记录",
          path: "/invest_log/audits",
          component: () => import("@/views/invest_log/audits.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "纠错记录",
          path: "/invest_log/correct",
          component: () => import("@/views/invest_log/correct.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "团队管理",
          path: "/invest_team/teams",
          component: () => import("@/views/invest_team/teams.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "投资经理主页",
          path: "/invest_team/profile",
          component: () => import("@/views/invest_team/profile.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "投资评估",
          path: "/invest_audit/estimate",
          component: () => import("@/views/invest_audit/pagination.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "投资合作",
          path: "/invest_audit/cooperate",
          component: () => import("@/views/invest_audit/pagination.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "营业信息",
          path: "/invest_audit/business",
          component: () => import("@/views/invest_audit/pagination.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "纠错审核",
          path: "/invest_audit/correct",
          component: () => import("@/views/invest_audit/pagination.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "风控-评估审核",
          path: "/invest_audit/estimate_audit",
          component: () => import("@/views/invest_audit/estimate.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "风控-合作审核",
          path: "/invest_audit/cooperate_audit",
          component: () => import("@/views/invest_audit/cooperate.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "风控-营业信息审核",
          path: "/invest_audit/business_audit",
          component: () => import("@/views/invest_audit/business.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "风控-合作纠错审核",
          path: "/invest_correct/cooperate",
          component: () => import("@/views/invest_correct/cooperate.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "风控-营业纠错审核",
          path: "/invest_correct/business",
          component: () => import("@/views/invest_correct/business.vue"),
          meta: { requireAuth: true }
        },
        {
          name: "问卷调查",
          path: "/invest_system/index",
          component: () => import("@/views/invest/index.vue"),
          meta: { requireAuth: true }
        },
      ]
    },
    {
      path: "*",
      name: "404",
      component: () => import("@/views/404.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  Vue.prototype.$httpRequestList.forEach((cancel: any) => {
    cancel();
  });
  // 检查是否有 redirect
  if (to.matched.some((r: any) => r.meta.redirect)) {
    // @ts-ignore
    router.push(to.meta.redirect);
    return;
  }

  store.dispatch("setGPagination", null);
  // console.log(next)
  // console.log(from)
  if (to.matched.some((r: any) => r.meta.requireAuth)) {
    if (_.get(store, ["state", "user", "token"])) {
      // 如果是登录过来的获取刷新页面的，获取下用户信息、用户菜单和用户权限
      if (from.path === "/" || from.path === "/login") {
        store.dispatch("user/getCurrentUserInfo", {}).then(() => {
          next();
        });
      } else {
        next();
      }
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

export default router;
